import { render } from "./App.vue?vue&type=template&id=7ff4494e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnkabiu/Development/Projects/Liden/Front-End/VueJs/mobi_games/mobi_games/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__